import React, { useEffect, useState } from 'react';
import loadable from '@loadable/component';
import { showSize } from '../../helpers/spot-size';
import { IMG_RESIZES } from '../../consts/resizer.consts';
import { ImageHelper } from '../../classes/image-helper.class';
import { SIGN_UP_SRC } from '../../consts/profile.const';
import { SPOT_ENCLOSURE } from '../../consts/spot.consts';
import { showDistanceFromYou } from '../../helpers/spot';
import RenderSpotSniffpass from './render-spot-sniffpass';
import RequestMorePhotos from '../../components/request-more-photos';
import SpotBreadcrumbs from '../../components/spot-breadcrumbs';
import RenderHostInfo from './render-host-info';
import RenderSubInfo from './render-sub-info';
import RenderRating from './render-rating';
import SniffButton from '../../components/sniff-button';
import PictureSet from '../../components/picture-set';
import SvgLocation from 'src/assets/svg/SvgLocation.svg';
import SvgFenced from 'src/assets/svg/SvgFenced.svg';
import SvgRuler from 'src/assets/svg/SvgRuler.svg';

const SpotFavFab = loadable(() => import('../../components/SpotFavFab'));
const SpotFavFabSSR = loadable(() => import('../../components/SpotFavFab/fav-ssr'));
const SpotShareButton = loadable(() => import('../../components/spot-share-button'));
const SpotShareButtonSSR = loadable(() => import('../../components/spot-share-button/share-ssr'));
const DesktopPhotoGallery = loadable(() => import('./desktop-photo-gallery'));

const RenderHeadDesktop = ({
    listBread,
    spot,
    goToHost,
    goToReviews,
    toggleDesktopPhotoGallery,
    desktopPhotoCount,
    desktopPhotoGallery,
    handleNextDesktopGallery,
    handleBackDesktopGallery,
    handleSniffpassBadge,
    SSR,
    useState: useStateSSR,
    useCallback,
    isMobile,
    favSpots,
    publicPark,
    handleChangeStars,
    rating,
    setRating,
    userDetails,
    spotPhotos,
    useGetShareLink,
    useMutateFavorites,
    setDesktopPhotoCount,
    isSpotLastActTest,
    lastActiveAt,
    spotPublishedAt,
    isRecentReviewsTest,
}) => {
    const [distanceText, setDistanceText] = useState('');
    const creatorName = `${spot?.host?.nameAndInitial} | Sniffspot` || undefined;
    const canShowGallery = SSR ? desktopPhotoGallery : userDetails.id && desktopPhotoGallery;

    let myPhotos = publicPark ? spot?.allPhotos?.map((p) => ({ imageAws: p })) : spot.spotPhotos;

    if (spotPhotos) {
        myPhotos = spotPhotos;
    }

    const photosCount = publicPark ? myPhotos?.length : SSR ? spot.photosCount : myPhotos?.length || 0;

    useEffect(() => {
        setDistanceText(showDistanceFromYou(spot.distanceFrom, userDetails));
    }, []);

    return (
        <div className="desktop-header d-md-block d-none">
            <SpotBreadcrumbs {...{ SSR, listBread }} />
            <h1 className="snif-l2 snif-semibold">{spot.title || spot.parkName}</h1>
            {publicPark && (
                <p className="snif-xs snif-bold text-light mt-1" style={{ letterSpacing: '1px' }}>
                    PUBLIC DOG PARK
                </p>
            )}
            <div className="header-info mt-2">
                <div className="info-left">
                    <div className="spot-location">
                        <SvgLocation />
                        {publicPark ? (
                            spot.address
                        ) : (
                            <>
                                {spot.city ? <span>{spot.city}</span> : null}
                                {spot.state ? <span>, {spot.state}</span> : null}
                                {distanceText}
                            </>
                        )}
                    </div>
                    {!publicPark && (
                        <>
                            <RenderHostInfo spot={spot} handleGoTo={goToHost} useState={useStateSSR} />
                            {spot.offerSniffpass && <RenderSpotSniffpass {...{ handleSniffpassBadge }} />}
                        </>
                    )}
                </div>
                <div className="spot-core-action">
                    {!publicPark &&
                        (SSR ? (
                            favSpots === undefined ? (
                                ''
                            ) : (
                                <SpotFavFabSSR
                                    src={SIGN_UP_SRC.FAVORITE_SPOT_WEB}
                                    {...{ spot, favSpots, userDetails, useState: useStateSSR, useCallback, useMutateFavorites }}
                                />
                            )
                        ) : (
                            <SpotFavFab src={SIGN_UP_SRC.FAVORITE_SPOT_WEB} spot={spot} />
                        ))}

                    {SSR ? (
                        <SpotShareButtonSSR
                            media={myPhotos && myPhotos?.length !== 0 && myPhotos[0].imageAws}
                            {...{ spot, useState: useStateSSR, isMobile, useGetShareLink }}
                        />
                    ) : (
                        <SpotShareButton media={myPhotos && myPhotos?.length !== 0 && myPhotos[0].imageAws} {...{ spot }} />
                    )}
                </div>
            </div>
            <div className="spot-header-detail">
                <RenderSubInfo
                    spot={spot}
                    handleGoTo={goToReviews}
                    isMobileSSR={isMobile}
                    isSpotLastActTest={isSpotLastActTest}
                    spotPublishedAt={spotPublishedAt}
                    lastActiveAt={lastActiveAt}
                    isRecentReviewsTest={isRecentReviewsTest}
                />
                <div className="spot-core-detail snif-s1">
                    {spot.enclosureType && (
                        <div className="head-info-box">
                            <SvgFenced />
                            {SPOT_ENCLOSURE[spot.enclosureType?.toUpperCase()]}
                        </div>
                    )}
                    {spot.size && (
                        <div className="head-info-box">
                            <SvgRuler />
                            {showSize(spot.size, spot.sizeUnits)}
                        </div>
                    )}
                </div>
            </div>
            {publicPark && !spot.isReviewed && (
                <div className="pt-1 pb-4">
                    <RenderRating {...{ handleChangeStars, rating, setRating }} />
                </div>
            )}
            {photosCount > 1 ? (
                <>
                    <div className="spot-photos-block">
                        <div className={`img-big ${photosCount == 2 ? 'two-img' : ''}`}>
                            <div className="desktop-photo" onClick={() => toggleDesktopPhotoGallery(0)}>
                                <PictureSet
                                    imgs={ImageHelper.getUrlFromOptions(myPhotos[0].imageAws, `full-fit-in/${IMG_RESIZES.x768}`)}
                                    className="photos-item"
                                    method="eager"
                                    fetchpriority="high"
                                    alt={`${spot.title} - ${spot.city}, ${spot.state}`}
                                    SSR={SSR}
                                    width={800}
                                    height={532}
                                    creatorName={creatorName}
                                />
                            </div>
                        </div>
                        <div className={`img-sml ${photosCount == 2 ? 'two-img' : ''}`}>
                            <div className="desktop-photo" onClick={() => toggleDesktopPhotoGallery(1)}>
                                <PictureSet
                                    imgs={ImageHelper.getUrlFromOptions(myPhotos[1]?.imageAws || '', `full-fit-in/${IMG_RESIZES.x768}`)}
                                    className="photos-item"
                                    method="eager"
                                    fetchpriority="high"
                                    alt={`${spot.title} - ${spot.city}, ${spot.state}`}
                                    SSR={SSR}
                                    width={500}
                                    height={320}
                                    creatorName={creatorName}
                                    force
                                    canLoading
                                />
                            </div>
                            {photosCount > 2 ? (
                                <div className="desktop-photo" onClick={() => toggleDesktopPhotoGallery(2)}>
                                    <PictureSet
                                        imgs={ImageHelper.getUrlFromOptions(myPhotos[2]?.imageAws || '', `full-fit-in/${IMG_RESIZES.x768}`)}
                                        className="photos-item"
                                        method="eager"
                                        fetchpriority="high"
                                        alt={`${spot.title} - ${spot.city}, ${spot.state}`}
                                        SSR={SSR}
                                        width={500}
                                        height={320}
                                        creatorName={creatorName}
                                        force
                                        canLoading
                                    />
                                </div>
                            ) : (
                                ''
                            )}
                        </div>
                        <SniffButton color="secondary" className="show-all-photo" onClick={() => toggleDesktopPhotoGallery()}>
                            Show all photos
                        </SniffButton>
                    </div>
                </>
            ) : (
                <>
                    <div className="spot-photos-block">
                        <div className="img-big full-img">
                            {photosCount > 0 ? (
                                <div className="desktop-photo" onClick={() => toggleDesktopPhotoGallery(0)}>
                                    <PictureSet
                                        imgs={ImageHelper.getUrlFromOptions(myPhotos[0].imageAws, `full-fit-in/${IMG_RESIZES.x1536}`)}
                                        className="photos-item"
                                        method="eager"
                                        fetchpriority="high"
                                        alt={`${spot.title} - ${spot.city}, ${spot.state}`}
                                        SSR={SSR}
                                        width={800}
                                        height={532}
                                        creatorName={creatorName}
                                    />
                                </div>
                            ) : (
                                <RequestMorePhotos id={spot.id} publicPark={publicPark} />
                            )}
                        </div>
                        {photosCount > 1 && (
                            <SniffButton color="secondary" className="show-all-photo" onClick={() => toggleDesktopPhotoGallery()}>
                                Show all photos
                            </SniffButton>
                        )}
                    </div>
                </>
            )}
            <hr />
            <DesktopPhotoGallery
                photos={myPhotos}
                currentPhoto={desktopPhotoCount}
                isOpen={canShowGallery}
                toggle={toggleDesktopPhotoGallery}
                hostId={spot.host?.id}
                spotId={spot.id}
                handleNext={handleNextDesktopGallery}
                handleBack={handleBackDesktopGallery}
                title={spot.title}
                state={spot.state}
                city={spot.city}
                useState={useStateSSR}
                setDesktopPhotoCount={setDesktopPhotoCount}
                publicPark={publicPark}
            />
        </div>
    );
};

export default RenderHeadDesktop;
